export default function growShrinkColor (value, type) {
    
    if (value > 0) {
		return type === 'bg' ? 'bg-success-100 dark:bg-success-500/20 dark:text-success-100' : 'text-success-600 dark:text-success-400'
	}

	if (value < 0) {
		return type === 'bg' ? 'bg-red-100 dark:bg-red-500/20 dark:text-red-100' : 'text-red-600 dark:text-red-500'
	}

    return ''
}